export namespace VeranstaltungsTypenEntityTypes {
    export const VER_TYP_ENTITY = 'VERTYPEN.VERTYP';
    export const VER_TYP_ENTITY_PART_ADMIN_ROLLEN = 'ADMINROLLEN';
    export const VER_TYP_ENTITY_PART_FELD = 'FELD';
    export const VER_TYP_ENTITY_PART_STAMM = 'STAMM';
    
}

